var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_828_599)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14,
    width: 100,
    height: 100,
    rx: 30,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4739 54.7863C47.4739 56.2028 46.3533 57.3073 44.9836 57.3073C43.5671 57.3073 42.4612 56.1867 42.4612 54.7863C42.4612 53.4006 43.614 52.2961 45.0144 52.2961C46.3533 52.28 47.4739 53.4313 47.4739 54.7863Z",
    fill: "url(#paint0_linear_828_599)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6958 61.0264C42.6958 59.9673 42.7266 59.6875 43.0063 59.1733C43.3345 58.5039 44.127 58.0527 44.9531 58.0527C45.7456 58.0527 46.5395 58.5039 46.8662 59.1733C47.1475 59.6875 47.1782 59.9365 47.1782 61.0264V70.9097C47.1782 71.9687 47.1475 72.2485 46.8662 72.7627C46.5395 73.4321 45.7456 73.8833 44.9531 73.8833C44.127 73.8833 43.3491 73.4321 43.0063 72.7627C42.7266 72.2485 42.6958 71.9995 42.6958 70.9097V61.0264Z",
    fill: "url(#paint1_linear_828_599)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4355 60.5767C49.4355 59.0195 50.3218 57.9766 51.6606 57.9766C52.5483 57.9766 53.0303 58.2886 53.8242 59.4399C55.0693 58.3032 56.1753 57.8828 57.7632 57.8828C58.8677 57.8828 59.9883 58.1641 60.813 58.646C61.2642 58.895 61.5454 59.1602 62.0581 59.8442C63.8642 58.3809 65.0464 57.8828 66.7588 57.8828C69.8716 57.8828 72.1596 60.0786 72.1596 63.0815V70.8965C72.1596 71.9702 72.1289 72.2339 71.8491 72.7641C71.5063 73.4336 70.7124 73.8994 69.9184 73.8994C69.0937 73.8994 68.2998 73.4482 67.957 72.7641C67.6772 72.25 67.6465 72.001 67.6465 70.8965V64.0791C67.6465 62.708 66.728 61.7588 65.3584 61.7588C63.9888 61.7588 63.0073 62.708 63.0073 64.0791V70.8965C63.0073 71.9702 62.9766 72.2339 62.6968 72.7641C62.354 73.4336 61.56 73.8994 60.7661 73.8994C59.9414 73.8994 59.1475 73.4482 58.8047 72.7641C58.5249 72.25 58.4941 72.001 58.4941 70.8965V64.5142C58.4941 62.771 57.6372 61.7588 56.1753 61.7588C54.8364 61.7588 53.855 62.7402 53.855 64.0791V70.8965C53.855 71.9702 53.8242 72.2339 53.5444 72.7641C53.2017 73.4336 52.4077 73.8994 51.6138 73.8994C50.7891 73.8994 49.9951 73.4482 49.6523 72.7641C49.3726 72.25 49.3418 72.001 49.3418 70.8965V60.5767H49.4355Z",
    fill: "url(#paint2_linear_828_599)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6819 60.3574C88.0676 61.8208 88.8147 63.8599 88.8147 66.1011C88.8147 70.7856 85.4221 74.3042 80.9075 74.3042C78.7131 74.3042 76.5496 73.3696 75.1023 71.8125C73.6858 70.3183 72.9695 68.3423 72.9695 65.9766C72.9695 61.415 76.425 57.8672 80.9075 57.8672C83.071 57.8672 85.2346 58.8003 86.6819 60.3574ZM77.6394 66.0381C77.6394 68.3423 78.9929 70.0386 80.7991 70.0386C82.6667 70.0386 84.1301 68.2954 84.1301 66.0703C84.1301 63.8906 82.6814 62.1313 80.7991 62.1313C79.0398 62.1475 77.6394 63.8599 77.6394 66.0381Z",
    fill: "url(#paint3_linear_828_599)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7355 100.81C57.0465 100.81 49.9172 98.4448 44.0182 94.4135C41.2321 95.8769 34.9743 96.2036 32.2512 95.8769C28.2814 95.4096 24.1257 92.1254 28.1262 88.9189C34.3371 83.9692 32.6716 82.0078 32.6716 82.0078C29.6979 76.7006 28.0017 70.5673 28.0017 64.0459C28.0017 43.749 44.4533 27.2812 64.7502 27.2812C85.047 27.2812 101.5 43.7329 101.5 64.0459C101.5 84.3588 85.0324 100.81 64.7355 100.81ZM64.7355 32.6675C47.2863 32.6675 33.1389 46.8149 33.1389 64.2802C33.1389 70.2876 34.819 75.9067 37.7297 80.685C37.7297 80.685 39.7995 86.0551 34.4924 90.0556C37.8234 91.1762 44.8429 89.121 45.2018 89.121C50.5705 93.3559 57.3571 95.893 64.7355 95.893C82.1832 95.893 96.3322 81.7441 96.3322 64.2802C96.3322 46.8149 82.1832 32.6675 64.7355 32.6675Z",
    fill: "url(#paint4_linear_828_599)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_828_599",
    x1: 37.0603,
    y1: 80.9411,
    x2: 46.2434,
    y2: 50.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_828_599",
    x1: 40.0181,
    y1: 81.9458,
    x2: 49.2012,
    y2: 50.9717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_828_599",
    x1: 60.564,
    y1: 74.9424,
    x2: 60.876,
    y2: 52.9961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_828_599",
    x1: 81.2649,
    y1: 78.2109,
    x2: 80.1765,
    y2: 49.5703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_828_599",
    x1: 65.1398,
    y1: 97.6669,
    x2: 64.9889,
    y2: 32.4492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_828_599"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImo);
export default __webpack_public_path__ + "static/media/Imo.f5ed4181ee5ce4055f63c9e3cfa0074f.svg";
export { ForwardRef as ReactComponent };